var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Holiday as HolidayModel } from '@/models/Holiday';
import ErrorHandler from '@/support/ErrorHandler';
let AddHolidayDialog = class AddHolidayDialog extends Vue {
    constructor() {
        super(...arguments);
        this.isEditingStartDate = false;
        this.isCreatingHoliday = false;
        this.isEditingEndDate = false;
        this.holiday = new HolidayModel();
    }
    mounted() { }
    close() {
        this.clear();
        this.$emit('input', false);
    }
    clear() {
        this.holiday = new HolidayModel();
    }
    create() {
        this.holiday.description = '  ';
        this.isCreatingHoliday = true;
        this.holiday
            .create()
            .then((holiday) => {
            this.isCreatingHoliday = false;
            this.$emit('holidayCreated');
            this.$emit('input', false);
            this.clear();
        })
            .catch((error) => {
            this.isCreatingHoliday = false;
            ErrorHandler.network(error);
        });
    }
};
AddHolidayDialog = __decorate([
    Component({
        components: {
        //
        },
    })
], AddHolidayDialog);
export default AddHolidayDialog;
